// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__RCke+","menu":"SideMenu_menu__66POH","menu__item":"SideMenu_menu__item__3UW5l","btn-content":"SideMenu_btn-content__u0674"};